import Vue from 'vue'       
import MarqueeText from 'vue-marquee-text-component'

function view (path) {
  return import(`@/components/${path}.vue`)
}
const globalComponent = [
  {
    name: 'marquee-text',
    component: MarqueeText
  }, 
  {
    name: 'title-tab',
    component: () => view('Titletab')
  },  
  {
    name: 'n-dialog',
    component: () => view('Dialog/DialogFormat')
  },
  {
    name: 'n-text-field-specific',
    component: () => view('TextField/TextFieldSpecificString')
  },
  {
    name: 'n-text-field-free',
    component: () => view('TextField/TextFieldFreeString')
  }, 
  {
    name: 'n-text-field-no-space',
    component: () => view('TextField/TextFieldNoSpace')
  }, 
  {
    name: 'n-text-field-noemoji',
    component: () => view('TextField/TextFieldSpecificStringFilterEmoji')
  }, 
  {
    name: 'n-text-field-username',
    component: () => view('TextField/TextFieldSpecificUsername')
  },     
  {
    name: 'n-select-bank-type',
    component: () => view('SelectField/SelectBankType')
  }, 
  {
    name: 'n-select-game-type',
    component: () => view('SelectField/SelectGameType')
  }, 
  {
    name: 'n-select-numbertemplate-type',
    component: () => view('SelectField/SelectNumberTemplateType')
  }, 
  {
    name: 'n-number-field-specific',
    component: () => view('TextField/TextFieldSpecificNumber')
  },  
  {
    name: 'loading-status',
    component: () => view('Loading')
  },  
  {
    name: 'n-pagination',
    component: () => view('Pagination')
  },
  {
    name: 'n-empty',
    component: () => view('Empty')
  },
  {
    name: 'n-datepicker-range',
    component: () => view('DatePickerRange')
  },   
  
  {
    name: 'n-card-voucher',
    component: () => view('Card/CardVoucher')
  },
  {
    name: 'pullpole-card',
    component: () => view('Card/cardPullPole')
  }, 
  
  {
    name: 'one-column-card',
    component: () => view('Card/oneColumnCard')
  },
  {
    name: 'two-column-card',
    component: () => view('Card/twoColumnCard')
  },
  {
    name: 'three-column-card',
    component: () => view('Card/threeColumnCard')
  },
  {
    name: 'three-plus-column-card',
    component: () => view('Card/threePlusColumnCard')
  },
  {
    name: 'four-column-card',
    component: () => view('Card/fourColumnCard')
  },
  {
    name: 'five-column-card',
    component: () => view('Card/fiveColumnCard')
  },
  {
    name: 'index-two-column-card',
    component: () => view('Card/twoColumnIndex')
  },
  {
    name : 'two-column-yeekee-card',
    component: () => view('Card/twoColumnYeekeeCard')
  },

  // v2 
  {
    name : 'n-data-table-card-result',
    component: () => view('DataTable/DataTableWithCardResult')
  }, 
  {
    name : 'nt-dialog',
    component: () => view('Dialog/DialogFormatV2')
  }, 
  {
    name: 'n-card-reporter',
    component: () => view('Card/CardReportV2')
  },
  {
    name : 'n-btn-submit',
    component: () => view('Button/ButtonSubmit')
  },
  {
    name : 'n-btn-round',
    component: () => view('Button/ButtonRound')
  },
  {
    name : 'n-btn-outlined',
    component: () => view('Button/ButtonRoundOutline')
  },
  {
    name : 'n2-btn-submit',
    component: () => view('Button/ButtonSubmit-v2')
  },
  {
    name : 'n2-btn',
    component: () => view('Button/Button-v2')
  },
  {
    name : 'n-btn-toggle-check',
    component: () => view('Button/ButtonToggleCheckIcon')
  }, 
  {
    name : 'n-card-round-header',
    component: () => view('Card/CardRoundHeader')
  }, 
  
  
] 
globalComponent.map(item => (Vue.component(item.name, item.component)))

